import { useDatabaseData } from '@/components/page/hooks'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { workerRegistry } from '@/lib/agents/registry'
import { useTeamStore } from '@/lib/hooks/useTeam'
import { NodeProps } from '@xyflow/react'
import { Search } from "lucide-react"
import { useState } from 'react'
import { ConditionHandler } from '../condition'
import { InlineHandles, WorkerLabeledHandle } from '../handles'
import { useWorker } from '../hooks'
import { SwirlingEffectSpinner } from '../progress'
import { NodeLayout } from './node'
import { Label } from '@/components/ui/label'

const { vectorSearch } = workerRegistry

vectorSearch.icon = Search


export function VectorSearchNode(props: NodeProps) {

  const { selectedTeam } = useTeamStore()
  const worker = useWorker<VectorSearchWorker>(props.id)
  const [value, setValue] = useState(worker.parameters.source)

  let { data, loading } = useDatabaseData("kbsources", {
    fields: ["id", "title"],
    filter: (q) => q.eq("team", selectedTeam.id),
  })

  function onSearchChange(value: string) {
    worker.parameters.source = value
    setValue(value)
  }

  return <NodeLayout worker={worker} resizable minHeight={780}>

    <InlineHandles>
      <WorkerLabeledHandle handler={worker.fields.input} />
      <WorkerLabeledHandle handler={worker.fields.output} />
    </InlineHandles>

    <InlineHandles>
      <WorkerLabeledHandle handler={worker.fields.tool} />
      <WorkerLabeledHandle handler={worker.fields.textOutput} />
    </InlineHandles>

    <InlineHandles>
      <div></div>
      <WorkerLabeledHandle handler={worker.fields.references} />
    </InlineHandles>

    {loading && <div className='flex items-center justify-center'>
      <SwirlingEffectSpinner />
    </div>}

    {!loading && <div className='px-2 mt-4'>
      <Label>Collection</Label>
      <Select onValueChange={onSearchChange} defaultValue={worker.parameters.source} value={value}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select Source" />
        </SelectTrigger>
        <SelectContent>
          {data.map(item => <SelectItem key={item.id} value={item.id}>{item.title}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>}



    <ConditionHandler />
  </NodeLayout >

}
